<div class="button-container">
  <integrations-connect-to-service [service]="zoom" [connectionInfoKey]="serviceKey"></integrations-connect-to-service>
</div>
